import React, { useState } from 'react';
import loadable from '@loadable/component';
import { compose, render } from '@/utils/story-composer';
import ModalDialogService from '@/utils/modal-dialog-service';
import CloseIcon from '../icons/close';

const Transition = loadable(() => import('@headlessui/react').then(headlessUi => headlessUi.Transition), { ssr: true });
const TransitionChild = loadable(() => import('@headlessui/react').then(headlessUi => headlessUi.Transition.Child), {
	ssr: true,
});
const Dialog = loadable(() => import('@headlessui/react').then(headlessUi => headlessUi.Dialog), { ssr: true });
const DialogPanel = loadable(() => import('@headlessui/react').then(headlessUi => headlessUi.Dialog.Panel), {
	ssr: true,
});

function ModalDialog({ identifier, content }) {
	const [isOpen, setIsOpen] = useState(false);

	const service = ModalDialogService.getInstance();

	const onToggle = () => {
		setIsOpen(!isOpen);
	};

	service.register(identifier, onToggle);

	if (!isOpen) {
		return null;
	}

	return (
		<Transition appear show={isOpen}>
			<Dialog as="div" className="relative z-40" onClose={() => onToggle()}>
				<TransitionChild
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
				>
					<div className="fixed inset-0 bg-black bg-opacity-25" />
				</TransitionChild>

				<div className="fixed inset-0 overflow-y-auto">
					<div className="flex min-h-full items-center justify-center p-4 text-center">
						<TransitionChild
							enter="ease-out duration-300"
							enterFrom="opacity-0 scale-95"
							enterTo="opacity-100 scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 scale-100"
							leaveTo="opacity-0 scale-95"
							className="md:max-w-[75%]"
						>
							<DialogPanel className="relative transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
								<button type="button" className="absolute right-4 top-4" onClick={() => onToggle()}>
									<CloseIcon size="w-3 h-3" color="text-regent-grey" />
								</button>
								{render(content)}
							</DialogPanel>
						</TransitionChild>
					</div>
				</div>
			</Dialog>
		</Transition>
	);
}
compose('modal-dialog', ModalDialog);

export default ModalDialog;
